import { cva, type VariantProps } from 'class-variance-authority'

/**
 * Separator component style variants
 * Definește stilurile pentru componenta Separator
 */
export const separatorVariants = cva(
  'shrink-0 bg-border',
  {
    variants: {
      orientation: {
        horizontal: 'h-[1px] w-full',
        vertical: 'h-full w-[1px]',
      },
    },
    defaultVariants: {
      orientation: 'horizontal',
    },
  }
)

export type SeparatorVariants = VariantProps<typeof separatorVariants>
